import { render, staticRenderFns } from "./TextBlockAndPopBox.vue?vue&type=template&id=2ca87346&"
import script from "./TextBlockAndPopBox.vue?vue&type=script&lang=js&"
export * from "./TextBlockAndPopBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageMainPopBoxInner: require('/usr/src/motec/components/page/main/PopBoxInner.vue').default})
